// Shared Tailwind class helpers used by the NHS Hypertension Case-Finding
// consultation form components. Mirrors the patterns used in the existing
// NHS Contraception template (card / sectionBadge / inputs etc.).

export const buildHypertensionFormStyles = (isDarkMode: boolean) => ({
  card: `border rounded-2xl p-4 transition-colors duration-300 ${
    isDarkMode ? "border-gray-700 bg-gray-800" : "border-gray-200 bg-white"
  }`,
  sectionBadge: `flex items-center justify-center w-6 h-6 rounded-full text-sm font-semibold transition-colors duration-300 ${
    isDarkMode ? "bg-white text-black" : "bg-black text-white"
  }`,
  sectionTitle: `text-sm font-semibold transition-colors duration-300 ${
    isDarkMode ? "text-white" : "text-gray-900"
  }`,
  labelCls: `text-sm ${isDarkMode ? "text-gray-300" : "text-gray-700"}`,
  inputCls: isDarkMode
    ? "bg-gray-700 border-gray-600 text-white placeholder:text-gray-500"
    : "bg-white border-gray-300 text-gray-900 placeholder:text-gray-400",
  selectCls: isDarkMode
    ? "bg-gray-700 border-gray-600 text-white"
    : "bg-white border-gray-300 text-gray-900",
  selectContentCls: isDarkMode
    ? "bg-gray-700 border-gray-600"
    : "bg-white border-gray-300",
  radioCls: isDarkMode
    ? "border-gray-600 text-white"
    : "border-gray-300 text-black",
  radioLabelCls: `text-sm cursor-pointer ${
    isDarkMode ? "text-gray-300" : "text-gray-700"
  }`,
  helperText: `text-xs ${isDarkMode ? "text-gray-400" : "text-gray-500"}`,
});

export type HypertensionFormStyles = ReturnType<
  typeof buildHypertensionFormStyles
>;
